export const TESTIMONIAL_ACTIONS = {
  SET_STATE: "testimonial/setState",
  GET_TESTIMONIAL: "testimonial/getTestimonial",
  GET_TESTIMONIAL_BY_ID: "testimonial/getTestimonialById",
  CREATE_TESTIMONIAL: "testimonial/createTestimonial",
  UPDATE_TESTIMONIAL: "testimonial/updateTestimonial",
  DELETE_TESTIMONIAL: "testimonial/deleteTestimonial",
};
